import { useEffect, useRef, useImperativeHandle, forwardRef } from 'react'
import PropTypes from 'prop-types'
import gsap from 'gsap'

const SimpleMedia = forwardRef(({
  alt,
  className,
  delay,
  ease,
  src,
  prepareAnimation,
}, ref) => {
  const $root = useRef()

  useEffect(() => {
    if ($root.current && prepareAnimation) gsap.set($root.current, { opacity: 0, rotation: 5, scale: 1.2 })
  }, [])

  const animateIn = () => {
    gsap.to($root.current, { opacity: 1, rotation: 0, scale: 1, delay, ease, duration: 1.2 })
  }

  useImperativeHandle(ref, () => ({
    animateIn,
    ref: $root.current,
  }))

  return (
    <img
      ref={$root}
      className={className}
      src={src}
      alt={alt}
    />
  )
})

SimpleMedia.defaultProps = {
  delay: 0,
  ease: 'power3.inOut',
  prepareAnimation: false,
}

SimpleMedia.propTypes = {
  delay: PropTypes.number,
  ease: PropTypes.string,
  prepareAnimation: PropTypes.bool,
}

export default SimpleMedia
